const formulaButtonsKeys = {
    formulaButtons: (formulaId: number, messageContentId?: string) => [
        'formula_buttons',
        formulaId,
        messageContentId,
    ],
};

export default formulaButtonsKeys;
